import { render, staticRenderFns } from "./powerManage-maintain.vue?vue&type=template&id=beaf8b4c&scoped=true&"
import script from "./powerManage-maintain.vue?vue&type=script&lang=js&"
export * from "./powerManage-maintain.vue?vue&type=script&lang=js&"
import style0 from "./powerManage-maintain.vue?vue&type=style&index=0&id=beaf8b4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beaf8b4c",
  null
  
)

export default component.exports